/**
 * Read one localized field, without trusting it to be there.
 *
 * Game text arrives as a `{fr, en, de, es, pt}` dict — but only when the payload
 * is complete. A trimmed listing, an item the catalog could not resolve, or a
 * set the server named with a bare string all hand the same field over in a
 * shape `field[lang]` cannot index, and on `undefined` that throws a TypeError
 * reading "Cannot read properties of undefined (reading 'fr')". One of those
 * reached the admin journal on 2026-08-25 from the item tooltip.
 *
 * Missing text is not worth a crash: unnamed, an item still shows its icon, its
 * level and its stats. So every shape resolves to *something* here.
 *
 * The fallback chain is the caller's language, then English, then French —
 * matching the call sites this replaced. Several other components still inline
 * their own copy of this lookup with an fr-then-en chain; they are left alone
 * rather than quietly re-ordered.
 */
const FALLBACK_LANGS = ['en', 'fr'];

/**
 * @param {object|string|null|undefined} field  localized dict, or a plain string
 * @param {string} lang  preferred language code
 * @param {*} [fallback]  returned when nothing readable is there
 */
export function localizedText(field, lang, fallback = '') {
    if (field === null || field === undefined) return fallback;
    if (typeof field === 'string') return field;
    if (typeof field !== 'object') return String(field);
    if (field[lang]) return field[lang];
    for (const key of FALLBACK_LANGS) {
        if (field[key]) return field[key];
    }
    return fallback;
}

export default localizedText;
